/**
 * 转换数据类型
 * @param {any} val 
 */
export const valueType = (val) => {

    try {
        return JSON.parse(val)
    } catch (error) {
        if (val === "true") {
            return true;
        } else if (val === "false") {
            return false;
        } else if (Object.is(Number(val), NaN)) {
            return val;
        } else if (!Object.is(Number(val), NaN)) {
            return Number(val);
        }  else {
            return val;
        }
    }
}